import { httpClient } from '../api/http.client';
import {
  DashboardStatistics,
  ProductStatistics,
  OrderStatistics,
  ChartData,
} from '@/domain/entities';

export class StatisticsRepository {
  async getDashboard(): Promise<DashboardStatistics> {
    return httpClient.get<DashboardStatistics>('/api/admin/statistics/dashboard');
  }

  async getProducts(): Promise<ProductStatistics> {
    return httpClient.get<ProductStatistics>('/api/admin/statistics/products');
  }

  async getOrders(): Promise<OrderStatistics> {
    return httpClient.get<OrderStatistics>('/api/admin/statistics/orders');
  }

  async getOrdersChart(): Promise<ChartData> {
    return httpClient.get<ChartData>('/api/admin/statistics/orders/chart');
  }
}

export const statisticsRepository = new StatisticsRepository();

